"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebugProtectionFunctionIntervalTemplate = DebugProtectionFunctionIntervalTemplate;
function DebugProtectionFunctionIntervalTemplate() {
    return `
        (function () {
            {globalVariableTemplate}
    
            that.setInterval({debugProtectionFunctionName}, {debugProtectionInterval});
        })();
    `;
}
